import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import {
  Modal,
  ModalBody,
  ModalHeader,
} from "reactstrap"
import Invoice from "components/invoice"

const InvoiceModal = props => {
  const { isOpen, toggle, processData, invoiceItems } = props
  
  return (
    <Modal
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
      size="lg"
    >
      <ModalHeader toggle={toggle} tag="h4">
      </ModalHeader>
      <ModalBody>
        <Invoice processData={processData} invoiceItems={invoiceItems} invoiceData={{}} isPublic={false} />
      </ModalBody>

    </Modal>
  )
}

InvoiceModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  processData: PropTypes.object,
  invoiceItems: PropTypes.array
}

export default InvoiceModal
